import React, { ChangeEvent, FocusEvent, FC, useContext, useEffect, useState } from "react";
import TranslatedMessage from "../translations/TranslatedMessage";
import { TextField, Typography } from "@material-ui/core";
import { SchedulerCaseNameContextValue } from "./context/SchedulerCaseNameContext";
import { SchedulerContextValue } from "./context/SchedulerContext";

interface SchedulerCaseNameTextFieldProps {
  candidateId: string;
  examId: string;
}

const SchedulerCaseNameTextField: FC<SchedulerCaseNameTextFieldProps> = ({ candidateId, examId }) => {
  const { readonly } = useContext(SchedulerContextValue);
  const { examCandidateCaseNames, updateCaseName } = useContext(SchedulerCaseNameContextValue);
  const [value, setValue] = useState("");

  useEffect(() => {
    const schedulerExamCandidate = examCandidateCaseNames.find(
      (examCandidate) => examCandidate.candidateId === candidateId && examCandidate.examId === examId
    );
    const caseName = schedulerExamCandidate?.caseName;
    setValue(() => (caseName === undefined || caseName === null ? "" : caseName));
  }, [candidateId, examId, examCandidateCaseNames]);

  if (readonly) {
    return <Typography variant="body1">{value}</Typography>;
  }

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };

  // Performance optimization. Update value on blur to prevent unnecessary renders.
  const handleOnBlur = (event: FocusEvent<HTMLInputElement>) => {
    updateCaseName(candidateId, examId, value);
  };

  return (
    <TextField
      label={<TranslatedMessage id={"examApplication.field.case"} />}
      value={value}
      onBlur={handleOnBlur}
      onChange={handleOnChange}
    />
  );
};

export default SchedulerCaseNameTextField;
